'use strict';

angular.module('app.services')

.factory('sistemaApi', sistemaApiFactory);
sistemaApiFactory.$inject = ['$resource', '$sessionStorage', '$q', 'ConfigApp'];

function sistemaApiFactory($resource, $sessionStorage, $q, ConfigApp) {
    return {
        versao: function (params) {

            var defer = $q.defer();
            var versao = $sessionStorage.versao;

            // Verifica existe dados em cache
            if (versao) {
                defer.resolve(versao);
                return defer.promise;
            } else {
                // Busca dados na api
                return $resource(
                    ConfigApp.UrlApi + '/v1.0/csti/sistemas/' + ConfigApp.CentralAppId + '/info', 
                {},{ ignoreLoadingBar: true }
                ).get(params).$promise.then(function (response) {
                    $sessionStorage.versao = response.data;

                    return $sessionStorage.versao;
                });
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/sistema-api-service.js